/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Consent,
    ConsentFromJSON,
    ConsentToJSON,
    ConsentStatus,
    ConsentStatusFromJSON,
    ConsentStatusToJSON,
} from './';

/**
 *
 * @export
 * @interface ResponseConsent
 */
export interface ResponseConsent {
    /**
     *
     * @type {ConsentStatus}
     * @memberof ResponseConsent
     */
    consentStatus: ConsentStatus;
    /**
     *
     * @type {Consent}
     * @memberof ResponseConsent
     */
    consent?: Consent;
    /**
     *
     * @type {object}
     * @memberof ResponseConsent
     */
    metadata: object;
    /**
     *
     * @type {Date}
     * @memberof ResponseConsent
     */
    consentEffectiveStartDate?: Date;
}

export function ResponseConsentFromJSON(json: any): ResponseConsent {
    return ResponseConsentFromJSONTyped(json, false);
}

export function ResponseConsentFromJSONTyped(json: any, _: boolean): ResponseConsent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'consentStatus': ConsentStatusFromJSON(json['consent_status']),
        'consent': !exists(json, 'consent') ? undefined : ConsentFromJSON(json['consent']),
        'metadata': json['metadata'],
        'consentEffectiveStartDate': !exists(json, 'consent_effective_start_date') ? undefined : (new Date(json['consent_effective_start_date'])),
    };
}

export function ResponseConsentToJSON(value?: ResponseConsent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'consent_status': ConsentStatusToJSON(value.consentStatus),
        'consent': ConsentToJSON(value.consent),
        'metadata': value.metadata,
        'consent_effective_start_date': value.consentEffectiveStartDate === undefined ? undefined : (value.consentEffectiveStartDate.toISOString()),
    };
}
